import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
const getHighlightText = (text, highlight) => {
    if (!highlight) {
        return _jsx(_Fragment, { children: text });
    }
    const parts = text.split(new RegExp(`(${highlight})`, "gi"));
    return (_jsx(_Fragment, { children: parts.map((part, index) => (_jsx(Fragment, { children: part.toLowerCase() === highlight.toLowerCase() ? _jsx("b", { children: part }) : part }, index))) }));
};
export const HighlightText = ({ highlight, children }) => {
    if (typeof children === "string" && highlight) {
        return getHighlightText(children, highlight);
    }
    else {
        return _jsx(_Fragment, { children: children });
    }
};
